<template>
  <div class="snackbar">
    <v-snackbar v-model="status" :color="getSnackbarData.color" :timeout="getSnackbarData.timeout" top>
      <span> {{ getSnackbarData.text }} </span>
      <v-icon v-if="getSnackbarData.icon" small flat> {{ getSnackbarData.icon }} </v-icon><v-spacer></v-spacer>
      <v-btn class="p2" icon @click="status = false">
        <v-icon small flat>fas fa-times</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  name: "Snackbar",
  data() {
    return {
      status: false
    };
  },
  methods: {
    setStatus(statuesValue) {
      this.status = statuesValue;
    }
  },
  computed: {
    snackbar() {
      return this.$store.getters.snackbar;
    },
    getSnackbarData() {
      if (!this.snackbar || !this.snackbar.status) {
        return {};
      }

      this.setStatus(true);

      return {
        timeout: this.snackbar.timeout || 7000,
        color: this.snackbar && this.snackbar.color ? this.snackbar.color : "success",
        icon: this.snackbar.icon || "",
        text: this.snackbar.text || ""
      };
    }
  }
};
</script>
<style lang="scss">
.snackbar {
  .v-snack.v-snack--active {
    .v-snack__wrapper {
      .v-snack__content {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        font-weight: 600;
      }
    }
  }
  .v-icon {
    margin-left: 0.5rem;
  }
}
</style>
